import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["interval", "startTime", "endTime", "disabledTimes", "id", "name", "disabled", "onChange", "value", "onBlur"];
import React from "react";
import { EMPTY_ARR } from "../../helpers/logic/empties";
import SelectPrimitive from "../Select/Select/primitives";
import NoOptionsMessage from "./components/NoOptionsMessage";
import { createEventObject, formatTimeString, timeIntervals } from "./logic";
import { jsx as _jsx } from "react/jsx-runtime";
var TimePicker = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var _ref$interval = _ref.interval,
    interval = _ref$interval === void 0 ? 30 : _ref$interval,
    _ref$startTime = _ref.startTime,
    startTime = _ref$startTime === void 0 ? "0:00" : _ref$startTime,
    _ref$endTime = _ref.endTime,
    endTime = _ref$endTime === void 0 ? "23:59" : _ref$endTime,
    _ref$disabledTimes = _ref.disabledTimes,
    disabledTimes = _ref$disabledTimes === void 0 ? EMPTY_ARR : _ref$disabledTimes,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "TimePicker" : _ref$id,
    name = _ref.name,
    disabled = _ref.disabled,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? function () {
      return null;
    } : _ref$onChange,
    value = _ref.value,
    onBlur = _ref.onBlur,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var fullOptions = timeIntervals(interval, startTime, endTime, disabledTimes);
  var handleBlur = function handleBlur(event) {
    var formattedValue = formatTimeString(event.target.value);
    if (_onChange && event.target.value !== formattedValue) {
      _onChange(createEventObject(formattedValue, disabledTimes));
      if (onBlur) {
        onBlur(event);
      }
    }
  };
  return /*#__PURE__*/_jsx(SelectPrimitive, _extends({
    isMulti: false,
    valueRenderType: "typeahead",
    ref: forwardedRef,
    id: id,
    name: name,
    options: fullOptions,
    onChange: function onChange(event) {
      return _onChange(createEventObject(event.value, disabledTimes));
    },
    value: value,
    disabled: disabled,
    inputValue: value,
    onInputChange: function onInputChange(newValue) {
      return _onChange(createEventObject(newValue, disabledTimes));
    },
    noOptionsMessage: function noOptionsMessage() {
      return NoOptionsMessage({
        value: value
      });
    },
    placeholder: "HH:MM",
    onBlur: handleBlur
  }, restProps));
});
TimePicker.displayName = "TimePicker";
export default TimePicker;